export * from "./communication";
export * from "./contactPoint";
export { default as PatientIdentification } from "./patientIdentification";
export { default as PatientNames } from "./patientNames";